import script from "./MileageMng.vue?vue&type=script&setup=true&name=mileageUser&lang=js"
export * from "./MileageMng.vue?vue&type=script&setup=true&name=mileageUser&lang=js"

const __exports__ = script;

export default __exports__